import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { IClientGridView } from "./IClientGridView";
import { TreeView } from "../../Components/TreeView/TreeView";
import { AvailableFieldsConverter } from "./AvailableFieldsConverter";
import { AvailableTreeFieldComponent } from "./AvailableTreeFieldComponent";
import { ITreeField } from "./ITreeField";
import { AllLevelFilter } from "../../Components/TreeView/Modules/Filter/AllLevelFilter";
import { TreeNodeComponent } from "../../Components/TreeView/NodeComponents/TreeNodeComponent";

export type AvailableFieldsComponentProps = {
    model: IClientGridView
}

export class AvailableFieldsComponent extends JSXComponent {
    private props: AvailableFieldsComponentProps;
    private tree: TreeView;

    constructor(props: AvailableFieldsComponentProps) {
        super(props);
    }

    element: HTMLElement =
        <div className="available">
        </div>

    /** Checkbox for optional columns */
    checkboxShowOptionalColumns: HTMLInputElement =
        <input type="checkbox" className="form-check-input" name="gvspShowOptionalColumns" id="gvspShowOptionalColumns" />

    /**Show optional columns change event handler*/
    onShowOptionalColumnChange = (ev: Event) => {
        this.updateTreeOptionalColumnsVisibility((ev.target as HTMLInputElement).checked);
    }

    updateTreeOptionalColumnsVisibility(visible: boolean) {
        if (this.tree.nodes) {
            this.tree.nodes.forEach((node) => {
                this.updateOptionalColumnsVisibility(node, visible);
            });
        }

        if (this.tree.filteredTreeViewRef?.nodes) {
            this.tree.filteredTreeViewRef.nodes.forEach((node) => {
                this.updateOptionalColumnsVisibility(node, visible);
            });
        }
    }

    updateTreeOptionalColumnsVisibilityForCurrentState() {
        this.updateTreeOptionalColumnsVisibility(this.checkboxShowOptionalColumns.checked);
    }

    /** Recursive update of optional columns visibility */
    updateOptionalColumnsVisibility(node: TreeNodeComponent, visibility: boolean) {
        if (node.props.model.businessModel.isOptional) {
            if (visibility) {
                node.element.classList.remove("d-none");
            }
            else {
                node.element.classList.add("d-none");
            }
        }

        if (node.childNodes) {
            node.childNodes.forEach((child) => {
                this.updateOptionalColumnsVisibility(child, visibility);
            });
        }
    }

    /** Add checkbox for optional columns */
    getShowOptionalColumnsElement() {
        let optionalColumnsElement = <div className="list-view-optional-columns-toggle form-check">
            {this.checkboxShowOptionalColumns}
            <label className="form-check-label" for="gvspShowOptionalColumns">{Resources.Common.showOptionalColumns}</label>
        </div>
        this.checkboxShowOptionalColumns.checked = false;
        this.checkboxShowOptionalColumns.addEventListener("change", this.onShowOptionalColumnChange);
        return optionalColumnsElement;
    }

    /** Create search bar element */
    getSearchElement() {
        let inputElement: HTMLElement = <div className="list-view-search-container"><input type="textbox" placeholder={Resources.Common.search + "..."} className="form-control" /></div>;
        inputElement.addEventListener('keyup', this.handleFilter);
        return inputElement;
    }

    /** Call search functionality */
    handleFilter = (event: KeyboardEvent) => {
        let searchTerm = (event.target as HTMLInputElement).value;
        this.tree.filterTree(searchTerm, 0);
        this.updateTreeOptionalColumnsVisibilityForCurrentState();
        if (searchTerm || searchTerm !== '') {
            this.tree.forceExpandAll();
        }
    }

    render() {
        this.tree = new TreeView({
            businessModel: this.props.model.available,
            modelConverter: new AvailableFieldsConverter(),
            displayLevels: 100,
            childrenCollapsed: true,
            internalComponentType: AvailableTreeFieldComponent,
            //internalProps: AvailableTreeFieldComponentProps,
            allowDragDrop: true,
            //dragDropBusinessModelAction: this.updateCategoryContentAfterDragDrop,
            dropTargetClass: "tree-drop",
            insertOnTop: true,
            isDebug: false,
            preventDragOnNodesWithChildren: true,
            filter: new AllLevelFilter()
        });
        
        this.element.appendChild(this.getSearchElement());
        this.element.appendChild(this.getShowOptionalColumnsElement());
        this.element.appendChild(this.tree.render());
        this.updateTreeOptionalColumnsVisibility(false);
        return this.element;
    }

    getModelFromTree(elementId: string): ITreeField {
        let node = this.tree.nodes.find(n => n.clientId == elementId);
        if (!node && this.tree.filteredTreeViewRef?.nodes){
            node = this.tree.filteredTreeViewRef.nodes.find(n => n.clientId == elementId);
        }
        if (node) {
            return node.props.model.businessModel as ITreeField;
        }
        return null;
    }
}
